import Flex from "./utils/Flex";
import IconCopy from "./icons/IconCopy";
import IconVerifiedUser from "./icons/IconVerifiedUser";

import { classify } from "../helpers";
import { useToasts } from 'react-toast-notifications';

import ProfileThumbnail from '../assets/images/profile-thumb.png'

const UserbarUser = ({ className = '' }) => {


	const { addToast } = useToasts();

	const onCopyToClipboard = text => {
		var textArea = document.createElement("textarea");
		textArea.value = text;

		// Avoid scrolling to bottom
		textArea.style.top = "0";
		textArea.style.left = "0";
		textArea.style.position = "fixed";

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		document.execCommand('copy');
		addToast('Text copied to the clipboard', { emoji: '🥰' })

		document.body.removeChild(textArea);
	}

	return (
		<Flex itemsCenter className={classify('userbar-user', className)}>
			<img
				className="w-12 h-12 lg:w-16 lg:h-16 flex-shrink-0 rounded lg:rounded-xl object-cover object-center"
				src={ProfileThumbnail}
				alt="Profile thumbnail"
			/>
			<div className="text-base xl:text-xl text-primary font-bold ml-4">
				<h2 className="flex items-center">
					Phoria Username
					<IconVerifiedUser className="icon__secure w-4 h-4 ml-2" />
				</h2>
				<h4 className="flex items-center">
					Phoria.tv/phoriausername
					<IconCopy
						onClick={() => onCopyToClipboard('Phoria.tv/phoriausername')}
						className="icon__copy w-4 h-4 lg:w-5 lg:h-5 ml-4 cursor-pointer"
					/>
				</h4>
			</div>
		</Flex>
	)
}

export default UserbarUser
